import { Injectable } from '@angular/core';
import { Http } from '../pages/shared/http-client/http-client.component';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import { EnvironmentSpecificService } from '../environment-specific.service';
@Injectable()
export class ThemeService {
    
    constructor(private _http: Http,
        private _router: Router,
        private _envService: EnvironmentSpecificService) {

    }

    GetUserInfo(){
        return this._http.getCurrentUser();
    }
    
    RedirectToUserSystem() {
        window.location.href = this._envService.envSpecific.userURL;
    }

}
